import React, { Component } from 'react';
import { Debounce } from 'react-throttle';

import FilterMenu from './FilterMenu';
import SelectionMenu from './SelectionMenu';
import FilterSet from './FilterSet';
import ResetFilter from './ResetFilter';

import '../../../css/ArtistFilter.css';
import '../../../css/SearchBar.css';

class ArtistFilter extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      match: props.match || '',
      discovered: props.discovered || false,
      forgotten: props.forgotten || false,
      sort: props.sort || 'top',
      gender: props.gender,
      tag: props.tag,
      country: props.country,
      tourCountry: props.tourCountry,
      timePeriod: props.timePeriod,
      tags: props.tags,
      countries: props.countries,
      timePeriods: props.timePeriods,
      genders: props.genders,
      tourCountries: props.tourCountries,
      facetsReady: props.facetsReady
    }

    this.onChange = (query) => {
      this.setState(query); 
      props.onChange(query);
    };

  }

  componentWillReceiveProps(newProps) {
    this.setState({
      match: newProps.match,
      discovered: newProps.discovered || false,
      forgotten: newProps.forgotten || false,
      sort: newProps.sort || 'top',
      gender: newProps.gender,
      tag: newProps.tag,
      country: newProps.country,
      tourCountry: newProps.tourCountry,
      timePeriod: newProps.timePeriod,
      tags: newProps.tags,
      countries: newProps.countries,
      timePeriods: newProps.timePeriods,
      genders: newProps.genders,
      tourCountries: newProps.tourCountries,
      facetsReady: newProps.facetsReady
    });

  }

  componentDidMount() {
    if (this.refs.searchValue && this.refs.searchValue !== this.state.match) {
      this.refs.searchValue.value = this.state.match;
    }
  }

  currentQuery() {
    return {
      match: this.state.match,
      discovered: this.state.discovered,
      forgotten: this.state.forgotten,
      sort: this.state.sort,
      gender: this.state.gender,
      tag: this.state.tag,
      country: this.state.country,
      timePeriod: this.state.timePeriod,
      tourCountry: this.state.tourCountry
    }; 
  }

  search(evt) {
    evt.preventDefault();
    let match = evt.target.value;
    let query = this.currentQuery();
    query.match = match.trim().toLowerCase();
    this.onChange(query);
  }

  toggleDiscovered() {
    let query = this.currentQuery();
    query.discovered = !query.discovered;
    this.onChange(query);
  }

  toggleForgotten() {
    let query = this.currentQuery();
    query.forgotten = !query.forgotten;
    this.onChange(query);
  }

  selectGender(gender) {
    let query = this.currentQuery();
    query.gender = gender;
    this.onChange(query);
  }

  selectTag(tag) {
    let query = this.currentQuery();
    query.tag = tag;
    this.onChange(query);
  }

  selectCountry(country) {
    let query = this.currentQuery();
    query.country = country;
    this.onChange(query);
  }

  selectTourCountry(tourCountry) {
    let query = this.currentQuery();
    query.tourCountry = tourCountry;
    this.onChange(query);
  }

  selectTimePeriod(timePeriod) {
    let query = this.currentQuery();
    query.timePeriod = timePeriod;
    this.onChange(query);
  }

  selectSort(sort) {
    let query = this.currentQuery();
    query.sort = sort;
    this.onChange(query);
  }

  removeFilter(key, value) {
    let query = this.currentQuery();
    let index = query[key].indexOf(value);
    if (index > -1)
      query[key].splice(index, 1);
    this.onChange(query);
  }

  removeAllFilters(keys, evt) {
    evt.preventDefault();
    evt.stopPropagation();
    let query = this.currentQuery();
    keys.forEach((key) => {
      query[key] = [];
    });
    this.onChange(query);
  }

  render() {

    let active = (value) => value ? 'active' : '';

    let timePeriods = this.state.timePeriods || [];
    let tags = this.state.tags || [];
    let countries = this.state.countries || [];
    let tourCountries = this.state.tourCountries || [];
    let genders = this.state.genders || [];
    let sorts = ['top', 'latest'];

    let query = this.currentQuery();

    let filterKey = (filter) => { return `${filter.key}/${filter.value}` };

    let selectedFilters = Object.keys(query)
      .filter((key) => query[key] instanceof Array && query[key].length > 0)
      .map((key) => { return query[key].map((value) => { return {key, value} }) } )
      .reduce((a,b) => a.concat(b), []);


    let selectedFilterItems = selectedFilters.map((filter) => {
      return <ResetFilter key={filterKey(filter)} value={filter.value} onClick={this.removeFilter.bind(this, filter.key, filter.value)}/>
    });

    if (selectedFilterItems.length >= 2) {

      let filterKeys = selectedFilters.map((filter) => {
        return filter.key
      });

      let key = filterKey({key: 'all', value: 'all'});

      let resetAllFilter = <ResetFilter all={true} key={key} value={'all'} onClick={this.removeAllFilters.bind(this, filterKeys)}/>

      selectedFilterItems.push(resetAllFilter);

    }

    return (

      <div>

      <Debounce time="300" handler="onChange">
        <input type="text" ref="searchValue" onChange={this.search.bind(this)} className="searchBar" placeholder="Search"/>       
      </Debounce>

      <div className="filters">

        <label className={`clickable ${active(this.state.discovered)}`} onClick={this.toggleDiscovered.bind(this)}>Discovered</label>
        <label className={`clickable ${active(this.state.forgotten)}`} onClick={this.toggleForgotten.bind(this)}>Forgotten</label>
        
        {this.state.facetsReady && (<FilterSet>

          <FilterMenu title="tags" selectedItem={this.state.tag} items={tags} select={this.selectTag.bind(this)}/>

          <FilterMenu title="countries" selectedItem={this.state.country} items={countries} select={this.selectCountry.bind(this)}/>

          <FilterMenu title="years" selectedItem={this.state.timePeriod} items={timePeriods} select={this.selectTimePeriod.bind(this)}/>

          <FilterMenu title="vocals" selectedItem={this.state.gender} items={genders} select={this.selectGender.bind(this)}/>

          <FilterMenu title="Tour" selectedItem={this.state.tourCountry} items={tourCountries} select={this.selectTourCountry.bind(this)}/>

          <SelectionMenu title="sort" selectedItem={this.state.sort} items={sorts} select={this.selectSort.bind(this)}/>

        </FilterSet>)}

      </div>

      <ul className="selectedFilters">
        {selectedFilterItems}
      </ul>

    </div>
  );

  }

}

export default ArtistFilter;



// WEBPACK FOOTER //
// ./src/js/components/filter/ArtistFilter.jsx